export const SETUP_CONTAINER_UI_ID = 'setup-form-id';

const STICKY_HEADER_TESTID = 'plan-topbar-fixed-wrapper';
const STICKY_SCROLL_GAP = 24;

const getStickyHeaderOffset = () => {
  const stickyHeader = document.querySelector(`[data-testid="${STICKY_HEADER_TESTID}"]`);
  const stickyHeight = stickyHeader ? stickyHeader.getBoundingClientRect().height : 0;
  return stickyHeight + STICKY_SCROLL_GAP;
};

interface ScrollOptions {
  behavior?: ScrollBehavior;
}

/**
 * Scrolls the plan setup container so that the target element lands just below
 * the sticky topbar. Accounts for the sticky header height dynamically.
 */
export const scrollToSetupSection = (targetId: string, options?: ScrollOptions) => {
  const setupWrapElem = document.getElementById(SETUP_CONTAINER_UI_ID);
  const el = document.getElementById(targetId);
  if (!setupWrapElem || !el) return;

  const delta =
    el.getBoundingClientRect().top -
    setupWrapElem.getBoundingClientRect().top -
    getStickyHeaderOffset();

  setupWrapElem.scrollTo({
    top: setupWrapElem.scrollTop + delta,
    behavior: options?.behavior ?? 'auto',
  });
};
